<template>
  <data-grid-local 
    :key="componentKey"
    :data="sortedData"
    :sort="[{ dataId: initialSort.dataId, direction: initialSort.direction }]"
  >
    <template #header>
      <data-grid-search-header 
        :search-placeholder="searchPlaceholder" 
        :search-name="searchName"
        :endpoint-search-param="preselectedSearchParam"
        @reset-search="resetSearch"
        @submit-search="submitSearch"
        @clear-sort="clearSort"
      />
    </template>

    <data-grid-column
      v-slot="value"
      :data-id="columns[0].dataId"
      :title="columns[0].columnHeading"
      sort="desc"
      :sortable="isSortable(columns[0].sortable)"
    >
      <data-column
        :column-type="columns[0].columnType"
        :value="value"
        :csrf-token="csrfToken"
        :column-data-options="columns[0].columnDataOptions"
      />
    </data-grid-column>
    <data-grid-column
      v-slot="value"
      :data-id="columns[1].dataId"
      :title="columns[1].columnHeading"
      sort="desc"
      :sortable="isSortable(columns[1].sortable)"
    >
      <data-column
        :column-type="columns[1].columnType"
        :value="value"
        :csrf-token="csrfToken"
        :column-data-options="columns[1].columnDataOptions"
      />
    </data-grid-column>
    <data-grid-column
      v-slot="value"
      :data-id="columns[2].dataId"
      :title="columns[2].columnHeading"
      sort="desc"
      :sortable="isSortable(columns[2].sortable)"
    >
      <data-column
        :column-type="columns[2].columnType"
        :value="value"
        :csrf-token="csrfToken"
        :column-data-options="columns[2].columnDataOptions"
      />
    </data-grid-column>
    <data-grid-column
      v-slot="value"
      :data-id="columns[3].dataId"
      :title="columns[3].columnHeading"
      sort="desc"
      :sortable="isSortable(columns[3].sortable)"
    >
      <data-column
        :column-type="columns[3].columnType"
        :value="value"
        :csrf-token="csrfToken"
        :column-data-options="columns[3].columnDataOptions"
      />
    </data-grid-column>
    <data-grid-column
      v-slot="value"
      :data-id="columns[4].dataId"
      :title="columns[4].columnHeading"
      sort="desc"
      :sortable="isSortable(columns[4].sortable)"
    >
      <data-column
        :column-type="columns[4].columnType"
        :value="value"
        :csrf-token="csrfToken"
        :column-data-options="columns[4].columnDataOptions"
      />
    </data-grid-column>
  </data-grid-local>
</template>

<script>
import { defineComponent } from "vue";
import DataColumn from "../../data-column/data-column.vue";
import DataGridSearchHeader  from "../../search-header/data-grid-search-header.vue";

import { useLocalDataGrid } from "../use-local-data-grid/use-local-data-grid.js";

export default defineComponent({
  name: "LocalDataGridColumnsFive",
  components:{
    DataGridSearchHeader,
    DataColumn
  },
  props:{
    data:{
      type: Object,
      required: true
    },
    columns:{
      type: Object,
      required: true
    },
    initialSort:{
      type: Object,
      default: () => ({dataId: "", direction: ""})
    },
    searchBy:{
      type: String,
      required: true,
    },
    searchPlaceholder:{
      type: String,
      default: ""
    },
    searchName:{
      type: String,
      required: true
    },
    csrfToken:{
      type: String,
      required: true
    }
  },
  setup(props) {
    const {
      resetSearch,
      submitSearch,
      clearSort,
      componentKey,
      isSortable,
      preselectedSearchParam,
      sortedData
    } = useLocalDataGrid(props);
      
    return {
      isSortable,
      resetSearch,
      submitSearch,
      clearSort,
      preselectedSearchParam,
      componentKey,
      sortedData     
    };
  },
});
</script>
